import type { InjectionKey } from 'vue'

export const isRunSecondsContestKey = Symbol() as InjectionKey<
  ComputedRef<boolean>
>

export const isRunContestKey = Symbol() as InjectionKey<ComputedRef<boolean>>

export const isScoreContestKey = Symbol() as InjectionKey<ComputedRef<boolean>>

export const isVideoContestKey = Symbol() as InjectionKey<ComputedRef<boolean>>

export const isImageContestKey = Symbol() as InjectionKey<ComputedRef<boolean>>

export const isSoloContestKey = Symbol() as InjectionKey<ComputedRef<boolean>>

export const isLockedRankingKey = Symbol() as InjectionKey<
  ComputedRef<boolean | undefined>
>

export const activityWordingKey = Symbol() as InjectionKey<
  ComputedRef<'score' | 'temps'>
>

export const injectedFetchPostKey = Symbol() as InjectionKey<
  (slug?: string) => Promise<void>
>
export const isEndedContestKey = Symbol() as InjectionKey<ComputedRef<boolean>>

export const injectedInvitationApproveKey = Symbol() as InjectionKey<
  (slug: string) => Promise<void>
>

export const injectedInvitationDisapproveKey = Symbol() as InjectionKey<
  (slug: string) => Promise<void>
>
